import React, { useState, useEffect } from "react";
import { axiosReq } from "../../commons/axiosReq";
import User from "../../assets/icon/NewsIcons/MainAdmin/NewsPerson";
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch";
import MainAdminJobAppliesTable from "../../components/MainAdmin/Table/MainAdminJobAppliesTable";
import DetailJobApplyModal from "../../components/MainAdmin/Modals/DetailJobApplyModal";
import DeleteModalWriters from "../../components/MainAdmin/Modals/DeleteModalWriters";
import Select from "react-select";
import { DatePicker } from "zaman";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

const colourStyles = {
    control: (base) => ({ ...base, backgroundColor: "white", minHeight: 35, height: 35 }),
    valueContainer: (base) => ({ ...base, height: 35, padding: "0 8px" }),
    option: (base) => ({ ...base, backgroundColor: "white", color: "#000" }),
};

const statusOptions = [
    { value: "Draft", label: "پیش‌نویس" },
    { value: "Sent", label: "ارسال شده" },
    { value: "Interview", label: "مصاحبه" },
    { value: "Offer", label: "پیشنهاد" },
    { value: "Rejected", label: "رد شده" },
];

const MainAdminJobApplies = () => {
    const titleRow = ["موضوع", "شغل", "شرکت", "کاربر", "وضعیت", "ارسال"];
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [reCheck, setRecheck] = useState(false);
    const [allApplies, setAllApplies] = useState([]);
    const [countries, setCountries] = useState([]);
    const [data, setData] = useState(null);
    const [search, setSearch] = useState("");
    const [filterStatus, setFilterStatus] = useState(null);
    const [filterCountry, setFilterCountry] = useState(null);
    const [filterUser, setFilterUser] = useState("");
    const [filterDateFrom, setFilterDateFrom] = useState("");
    const [filterDateTo, setFilterDateTo] = useState("");
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    let navigate = useNavigate();

    const GetData = async () => {
        const res = await axiosReq("Job/Apply/Admin", "get");
        const list = Array.isArray(res) ? res : res?.data || [];
        setAllApplies(list);
    };

    const GetCountries = async () => {
        const res = await axiosReq("University/GetCountries", "get");
        const list = Array.isArray(res) ? res : res?.data || [];
        setCountries(list.map((c) => ({ value: c.countryId, label: c.name })));
    };

    const auth = async () => {
        const cookies = new Cookies();
        var token = cookies.get("token");
        if (!token) {
            navigate("/");
        } else {
            GetData();
            GetCountries();
        }
    };

    useEffect(() => {
        auth();
    }, [reCheck]);

    const filteredApplies = allApplies.filter((a) => {
        if (search) {
            const s = search.toLowerCase();
            if (
                !(a.subject || "").toLowerCase().includes(s) &&
                !(a.job?.title || "").toLowerCase().includes(s) &&
                !(a.job?.company || "").toLowerCase().includes(s)
            ) {
                return false;
            }
        }
        if (filterStatus && a.status !== filterStatus.value) {
            return false;
        }
        if (filterCountry && a.job?.countryId !== filterCountry.value) {
            return false;
        }
        if (filterUser) {
            const u = filterUser.toLowerCase();
            const userName = `${a.userName || ""} ${a.userFamily || ""} ${a.userEmail || ""}`.toLowerCase();
            if (!userName.includes(u)) {
                return false;
            }
        }
        if (filterDateFrom) {
            const d = new Date(filterDateFrom);
            const sentAt = a.sentAt ? new Date(a.sentAt) : null;
            if (!sentAt || sentAt < d) {
                return false;
            }
        }
        if (filterDateTo) {
            const d = new Date(filterDateTo);
            d.setHours(23, 59, 59, 999);
            const sentAt = a.sentAt ? new Date(a.sentAt) : null;
            if (!sentAt || sentAt > d) {
                return false;
            }
        }
        return true;
    });

    const count = filteredApplies.length;
    const pagedApplies = filteredApplies.slice((page - 1) * row, page * row);

    useEffect(() => {
        setPage(1);
    }, [search, filterStatus, filterCountry, filterUser, filterDateFrom, filterDateTo, row]);

    const fixNumber = (str) => {
        if (typeof str !== "string") return str;
        const persian = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
        const arabic = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        for (let i = 0; i < 10; i++) {
            str = str.replace(persian[i], i).replace(arabic[i], i);
        }
        return str;
    };

    const dateToString = (d) => {
        try {
            const parts = new Date(d).toLocaleDateString("fa-IR").split("/");
            const yy = fixNumber(parts[0]);
            const mm = fixNumber(parts[1]);
            const dd = fixNumber(parts[2]);
            return `${yy}/${mm.length === 1 ? "0" + mm : mm}/${dd.length === 1 ? "0" + dd : dd}`;
        } catch {
            return "";
        }
    };

    return (
        <div>
            <div className="p-[20px] flex flex-wrap justify-between items-center border-b-2 border-borderGray">
                <div className="flex justify-start items-center">
                    <div><User color={"black"} /></div>
                    <p className="font-IRANYekanExtra text-[15px] mr-[15px]">مدیریت درخواست‌های شغل</p>
                </div>
                <div className="flex flex-wrap justify-start items-center">
                    <div className="w-[238px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center mb-5">
                        <input
                            onChange={(e) => setSearch(e.target.value)}
                            className="font-IRANYekanNormal focus:outline-none placeholder-lightGray"
                            type="text"
                            placeholder="جستجوی موضوع، شغل ..."
                        />
                        <button><Search /></button>
                    </div>
                </div>
            </div>

            <div className="px-[20px] pt-[10px] pb-[5px] flex flex-wrap gap-3 items-center">
                <div className="w-[160px]">
                    <Select
                        options={statusOptions}
                        value={filterStatus}
                        onChange={setFilterStatus}
                        placeholder="فیلتر وضعیت"
                        isSearchable={false}
                        isClearable={true}
                        styles={colourStyles}
                    />
                </div>
                <div className="w-[160px]">
                    <Select
                        options={countries}
                        value={filterCountry}
                        onChange={setFilterCountry}
                        placeholder="فیلتر کشور"
                        isSearchable={true}
                        isClearable={true}
                        styles={colourStyles}
                    />
                </div>
                <div className="w-[150px] h-[35px] rounded-[10px] shadow-search-shadow flex items-center px-[10px]">
                    <input
                        onChange={(e) => setFilterUser(e.target.value)}
                        className="font-IRANYekanNormal text-[13px] focus:outline-none placeholder-lightGray w-full"
                        type="text"
                        placeholder="فیلتر کاربر ..."
                    />
                </div>
                <div className="flex items-center gap-2 text-[13px] font-IRANYekanNormal text-mainColor2">
                    <span>از:</span>
                    <div className="border-[1px] border-borderGray rounded-[5px] px-2 h-[35px] flex items-center w-[120px]">
                        <DatePicker
                            placeholder="تاریخ"
                            onChange={(e) => {
                                setFilterDateFrom(e.value ? dateToString(e.value) : "");
                            }}
                        />
                    </div>
                    <span>تا:</span>
                    <div className="border-[1px] border-borderGray rounded-[5px] px-2 h-[35px] flex items-center w-[120px]">
                        <DatePicker
                            placeholder="تاریخ"
                            onChange={(e) => {
                                setFilterDateTo(e.value ? dateToString(e.value) : "");
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="pt-[10px] px-[20px] pb-[280px]">
                <MainAdminJobAppliesTable
                    detail={true}
                    deleted={true}
                    setShowDetailModal={setShowDetailModal}
                    setShowDeleteModal={setShowDeleteModal}
                    setData={setData}
                    titleRow={titleRow}
                    writersList={pagedApplies}
                    count={count}
                    page={page}
                    setPage={setPage}
                    row={row}
                    setRow={setRow}
                />
            </div>

            {showDetailModal && data ? (
                <DetailJobApplyModal setShowModal={setShowDetailModal} data={data} />
            ) : null}

            {showDeleteModal ? (
                <DeleteModalWriters
                    title={"حذف درخواست"}
                    buttonName={"حذف"}
                    text={"آیا از حذف درخواست انتخاب شده اطمینان دارید ؟"}
                    setShowModal={setShowDeleteModal}
                    api={"Job/Apply/Admin/" + data?.jobApplyId}
                    reCheck={reCheck}
                    setRecheck={setRecheck}
                />
            ) : null}
        </div>
    );
};

export default MainAdminJobApplies;